export default "__VITE_ASSET__bFW0TL_I__"